import Icon from "../Icon";
import * as React from "react";
function next(direction) {
    switch (direction) {
        case "asc":
            return "desc";
        default:
            return "asc";
    }
}
class SortIndicator extends React.Component {
    render() {
        const { direction } = this.props;
        return (React.createElement("div", { style: { display: "inline" } },
            React.createElement(Icon, { name: this.icon(direction) })));
    }
    cycleDirection = () => {
        const { direction, onSetDirection } = this.props;
        onSetDirection(next(direction));
    };
    icon(direction) {
        switch (direction) {
            case "none":
                return "sort-none";
            case "asc":
                return "sort-up";
            case "desc":
                return "sort-down";
            default:
                return "question";
        }
    }
}
export default SortIndicator;
